const useFeatures = () => {

    const featureEnabledGrocerPointsConversion = () => {
        // @ts-ignore
        return window.rocAppConfig.featureEnabledGrocerPointsConversion;
    }

    return {
        featureEnabledGrocerPointsConversion
    }
}

export default useFeatures